/**
 * @fileoverview PATCH handler for the "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainDomainIdCacheKeys } from "./constants";
import type { PatchSendingDomainProps, PatchSendingDomainResult } from "./types";

export const patchSendingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainDomainIdCacheKeys,
  (props: PatchSendingDomainProps): Promise<PatchSendingDomainResult> => {
    const { companyId, appGroupId, domainId, ...requestBody } = props;

    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domain/${domainId}`,
      "PATCH",
      requestBody,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
